import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsOnboardingHubRoute: InvariantJiraRoute = {
	name: 'products-onboarding-hub',
	path: '/jira/settings/products/onboarding',
};
